<span *ngIf="tag.affichageProduit">
    <span *ngIf="!tag.url || tag.url === ''" class="label label-rounded label-success">{{ tag.label }}</span>
    <img *ngIf="tag.url && tag.url !== ''" [src]="env.baseFileUrl + tag.url" [alt]="tag.label">
</span>